import type { Tier } from '@auctionradar/shared';

const TIER_STYLES: Record<Tier, string> = {
  A: 'bg-rose-600 text-white',
  B: 'bg-amber-500 text-white',
  C: 'bg-slate-400 text-white',
  D: 'bg-slate-200 text-slate-600',
};

export function TierBadge({ tier }: { tier: Tier | null }) {
  if (tier == null) {
    return (
      <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500">
        —
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold tracking-wide ${TIER_STYLES[tier]}`}
    >
      {tier}
    </span>
  );
}
